import { render, staticRenderFns } from "./MaterialCategoryForm.vue?vue&type=template&id=356bd865&scoped=true&lang=pug&"
import script from "./MaterialCategoryForm.vue?vue&type=script&lang=js&"
export * from "./MaterialCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCategoryForm.vue?vue&type=style&index=0&id=356bd865&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bd865",
  null
  
)

export default component.exports